// extracted by mini-css-extract-plugin
export var locationCard = "_gb-0";